import { io, Socket } from 'socket.io-client';

class SocketService {
  private socket: Socket | null = null;

  connect(token?: string): Socket | null {
    if (!token) {
      return null;
    }

    if (!this.socket) {
      this.socket = io(process.env.SOCKET_CHAT_URL, {
        transports: ['websocket', 'polling'],
        forceNew: true,
        reconnection: true,
        timeout: 5000,
        extraHeaders: {
          Authorization: `Bearer ${token}`
        },
        auth: {
          token
        }
      });
    }
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  getSocket() {
    return this.socket;
  }
}

export const socketService = new SocketService();
